import { render, staticRenderFns } from "./ForumDialog.vue?vue&type=template&id=b8705e50&"
import script from "./ForumDialog.vue?vue&type=script&lang=js&"
export * from "./ForumDialog.vue?vue&type=script&lang=js&"
import style0 from "./ForumDialog.vue?vue&type=style&index=0&id=b8705e50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports